import { render, staticRenderFns } from "./PortefeuilleHousings.vue?vue&type=template&id=16ead690&scoped=true"
import script from "./PortefeuilleHousings.vue?vue&type=script&lang=js"
export * from "./PortefeuilleHousings.vue?vue&type=script&lang=js"
import style0 from "./PortefeuilleHousings.vue?vue&type=style&index=0&id=16ead690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ead690",
  null
  
)

export default component.exports